import { Phone, MessageSquare, MessageCircle, Mail, StickyNote, CalendarPlus, CalendarClock, Workflow, ClipboardList } from "lucide-react";

export const waNumber = (m) => {
  const d = String(m || "").replace(/\D/g, "");
  if (!d) return "";
  if (d.startsWith("44")) return d;
  if (d.startsWith("0")) return "44" + d.slice(1);
  return d;
};

const Btn = ({ icon: Icon, label, href, onClick, testId, disabled, primary }) => {
  const cls = `flex flex-col items-center justify-center gap-1 rounded-xl h-16 text-[11px] font-medium border transition-colors ${disabled ? "opacity-35 pointer-events-none border-white/10 text-emerald-100/50" : primary ? "bg-brass text-emerald-950 border-brass" : "bg-white/[0.04] border-white/10 text-emerald-50 hover:bg-white/10"}`;
  const body = <><Icon className="w-5 h-5" />{label}</>;
  return href
    ? <a href={href} className={cls} data-testid={testId} target={href.startsWith("http") ? "_blank" : undefined} rel="noreferrer">{body}</a>
    : <button type="button" onClick={onClick} className={cls} data-testid={testId}>{body}</button>;
};

export function QuickActions({ mobile, email, onEmail, onOutcome, onNote, onAppointment, onFollowup, onStatus }) {
  const wa = waNumber(mobile);
  return (
    <div className="grid grid-cols-3 sm:grid-cols-9 gap-2" data-testid="quick-actions">
      <Btn icon={Phone} label="Call" href={mobile ? `tel:${mobile}` : undefined} disabled={!mobile} primary testId="qa-call" />
      <Btn icon={MessageSquare} label="Text" href={mobile ? `sms:${mobile}` : undefined} disabled={!mobile} testId="qa-text" />
      <Btn icon={MessageCircle} label="WhatsApp" href={wa ? `https://wa.me/${wa}` : undefined} disabled={!wa} testId="qa-whatsapp" />
      <Btn icon={Mail} label="Email" onClick={onEmail} disabled={!email} testId="qa-email" />
      <Btn icon={ClipboardList} label="Log outcome" onClick={onOutcome} testId="qa-outcome" />
      <Btn icon={StickyNote} label="Add note" onClick={onNote} testId="qa-note" />
      <Btn icon={CalendarPlus} label="Appointment" onClick={onAppointment} testId="qa-appointment" />
      <Btn icon={CalendarClock} label="Follow-up" onClick={onFollowup} testId="qa-followup" />
      <Btn icon={Workflow} label="Status" onClick={onStatus} testId="qa-status" />
    </div>
  );
}
